// @ts-nocheck
import PropTypes from "prop-types";
import React, { useEffect, useCallback, useRef, useState } from "react";
import className from "./OutputSuggest.module.scss";
import { ApiPulldownList } from "./ApiPulldownList";
import { PulldownList } from "./PulldownList";
import { PulldownSearchForm } from "./PulldownSearchForm";
import { DbOperationSearchSelect } from "../operations/databaseOperations/DbOperationSearchSelect";
import { DbTriggerSearchSelect } from "../triggers/databaseTriggers/DbTriggerSearchSelect";
import { getImageUrl } from "../../../commons/assets_path";
import axios from "axios";
axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
import { DatePulldownList } from "./DatePulldownList";
import { BasicPulldownList } from "./BasicPulldownList";
import { useTranslation } from "react-i18next";

/**
 * @arg {PropTypes.InferProps.<typeof OutputSuggest.propTypes>} props
 * @return {ReturnType.<React.FC>}
 */

export const OutputSuggest = ({
  outputs,
  workflow_booted_at,
  target,
  isTagsInput = false,
  isTrix = false,
  pulldown,
  dataType,
  onSearch,
  isPulldownFlg,
  isTestFieldFlg,
  formName = null,
  selections,
  terms,
  addTerm,
  removeTerm,
  isYoomFlag,
  setTarget,
  isTrigger,
  topAdjust = 0,
  unnecessaryDateFlag = false,
  disable_suggest_date_types,
  except_past = false,
  setOutputs,
  styleOption = null,
  forceRender,
}) => {
  const { t } = useTranslation();
  const pullDownRef = useRef();
  const buttonRef = useRef();
  const [style, setStyle] = useState();
  const [isOpen, setOpen] = useState(false);
  const [fade, setFade] = useState(false);
  const [openPullDown, setOpenPullDown] = useState(false);
  const [currentOutputs, setCurrentOutputs] = useState(outputs.filter((output) => output.tab === "output"));
  const [basicOutputs, setBasicOutputs] = useState(outputs.filter((output) => output.tab === "basic"));
  const [tabList, setTabList] = useState([]);
  const [selectTab, setSelectTab] = useState(t("OutputSuggest.候補"));
  const [isSearchCompleted, setIsSearchCompleted] = useState(false);
  const [searchTimer, setSearchTimer] = useState(null);
  const [isSuggestClose, setIsSuggestClose] = useState(false);
  const [dateOutputOptions, setDateOutputOptions] = useState(null);
  const [workflowTemplateTitle, setWorkflowTemplateTitle] = useState(null);

  const getWorkflowTemplateTitle = () => {
    const endpoint = location.href.replace(
      /workflow_templates.*/,
      `workflow_templates/${window.location.pathname.split("/")[3]}/ajax_workflow_template_title`,
    );
    axios.get(endpoint, {}).then((res) => {
      setWorkflowTemplateTitle(res.data.workflow_template_title);
    });
  };

  const getDateOutputOptions = () => {
    const endpoint = location.href.replace(
      /workflow_templates.*/,
      `workflow_templates/${window.location.pathname.split("/")[3]}/date_output_options`,
    );
    axios
      .get(endpoint, {
        params: { except_past: except_past },
      })
      .then((response) => {
        setDateOutputOptions(response.data);
      });
  };

  const onClick = (event, output) => {
    if (isTagsInput) {
      setOutputs((prev) =>
        prev.some((prevOutputs) => prevOutputs.display_name === output.display_name) ? prev : [...prev, output],
      );
    } else if (isTrix) {
      target.current.editor.insertString(`{{${event.currentTarget.value}}}`);
      target.current.focus();
    } else {
      setOutputs(output);
    }
  };

  const onClickPulldown = useCallback(
    (event) => {
      setOutputs({ dataType: "api-pulldown", display_name: event.currentTarget.value });
      setOpenPullDown(false);
      setOpen(false);
    },
    [target],
  );

  const onClickDbTriggerPulldown = useCallback(
    (value) => {
      const payload = {
        dataType: "trigger-pulldown",
        display_name: value.name,
        ...(value?.id ? { id: value.id } : {}),
      };
      setOutputs(payload);
    },
    [target],
  );

  const onSearchOutputs = (targetValue) => {
    if (searchTimer) {
      clearTimeout(searchTimer);
    }

    // 入力毎にリクエストするのは負荷が高いため、300ms待ってからリクエストする
    const newTimer = setTimeout(() => {
      searchOutputs(targetValue);
    }, 300);

    setSearchTimer(newTimer);
  };

  const searchOutputs = async (targetValue) => {
    const endpoint = location.href.replace(
      /workflow_templates.*/,
      `workflow_templates/${window.location.pathname.split("/")[3]}/ajax_output_suggests`,
    );
    const templateActionableName = window.location.pathname.split("/")[4];
    const templateActionableId = window.location.pathname.split("/")[5];
    await axios
      .post(endpoint, {
        template_actionable_name: templateActionableName,
        template_actionable_id: templateActionableId,
        display_name: targetValue,
      })
      .then((res) => {
        setCurrentOutputs(res.data.output_suggests);
        if (targetValue) {
          setIsSearchCompleted(true);
        } else {
          setIsSearchCompleted(false);
        }
      });
  };

  const ocClickOuterClose = useCallback(
    (e) => {
      if (openPullDown) {
        if (!e.target.closest(".js-output-select")) {
          setOpen(false);
          setOpenPullDown(false);
        }
      }
    },
    [isOpen],
  );

  const outerClick = (e) => {
    if (!e.target.closest(".js-output-select")) {
      setSelectTab(tabList[0]);
      setIsSuggestClose((before) => !before);
    }
  };

  useEffect(() => {
    getDateOutputOptions();
    getWorkflowTemplateTitle();
  }, []);

  useEffect(() => {
    if (target) {
      let top = `${target?.current?.offsetHeight + topAdjust}px`;
      let left = 0;
      if (styleOption) {
        setStyle(styleOption);
      } else if (isYoomFlag) {
        top = `${target?.current?.offsetHeight - 22}px`;
        left = `${-target.current?.getBoundingClientRect().width - 5}px`;
        setStyle({
          left: left,
          position: "absolute",
          top: top,
          bottom: "auto",
        });
      } else {
        setStyle({
          left: left,
          position: "absolute",
          top: top,
          bottom: "auto",
        });
      }
    }
    function onFocus() {
      target?.current?.focus();
      setOpen(true);
    }

    function onBlur() {
      setOpen(false);
    }

    function onMouseOver() {
      setOpenPullDown(true);
      setOpen(true);
    }

    function onMouseOut() {
      setOpenPullDown(false);
    }

    function onCancelClick() {
      if (target.current !== null) {
        target.current.blur();
      }
      setOpenPullDown(false);
      setOpen(false);
    }
    if (target.current) {
      target.current.addEventListener("focus", onFocus);
      target.current.addEventListener("click", onFocus);
      target.current.addEventListener("blur", onBlur);
    }
    pullDownRef.current.addEventListener("mouseover", onMouseOver);
    pullDownRef.current.addEventListener("mouseout", onMouseOut);
    if (buttonRef.current) {
      buttonRef.current.addEventListener("click", onCancelClick);
    }
  }, [target.current, target?.current?.offsetHeight, topAdjust]);

  useEffect(() => {
    if (isOpen || openPullDown) {
      if (!fade) {
        setFade(true);
      }
    } else {
      if (fade) {
        setFade(false);
      }
    }
  }, [isOpen, openPullDown]);

  useEffect(() => {
    if (dataType !== "api_pulldown") {
      if (isTrigger) {
        setTabList([t("OutputSuggest.日付"), t("OutputSuggest.基本情報")]);
      } else if (unnecessaryDateFlag) {
        setTabList([t("OutputSuggest.取得した値"), t("OutputSuggest.基本情報")]);
      } else {
        setTabList([t("OutputSuggest.取得した値"), t("OutputSuggest.日付"), t("OutputSuggest.基本情報")]);
      }
    } else if (isTestFieldFlg) {
      setTabList([t("OutputSuggest.候補"), t("OutputSuggest.基本情報")]);
    } else if (isTrigger) {
      setTabList([t("OutputSuggest.候補"), t("OutputSuggest.日付"), t("OutputSuggest.基本情報")]);
    } else {
      setTabList([
        t("OutputSuggest.候補"),
        t("OutputSuggest.取得した値"),
        t("OutputSuggest.日付"),
        t("OutputSuggest.基本情報"),
      ]);
    }
  }, []);

  useEffect(() => {
    document.addEventListener("click", ocClickOuterClose);
    return () => {
      if (openPullDown) {
        document.removeEventListener("click", ocClickOuterClose);
      }
    };
  }, [isOpen]);

  useEffect(() => {
    if (tabList[0]) {
      setSelectTab(tabList[0]);
      document.addEventListener("click", outerClick);
      return () => {
        document.removeEventListener("click", outerClick);
      };
    }
  }, [tabList?.length]);

  return (
    <div
      className={`${className.details} ${fade ? className.view : className.disabled} js-output-select`}
      ref={pullDownRef}
    >
      <div className={className.content} style={{ ...style, overflow: "hidden" }}>
        <div className={className.header}>
          <div className={className.outputTab}>
            {tabList.map((tab, i) => (
              <div
                className={`${className.outputItemWrap} test-suggest_tab_list`}
                style={{
                  color: tab !== selectTab ? "#777777" : "#222222",
                  pointerEvents: tab !== selectTab ? "auto" : "none",
                }}
                key={i}
                onClick={() => {
                  setSelectTab(tab);
                  target.current.focus();
                }}
              >
                <div className={className.outputItem}>{tab}</div>
                <div
                  className={className.outputUnder}
                  style={{
                    display: tab !== selectTab ? "none" : "inline-block",
                  }}
                ></div>
              </div>
            ))}
          </div>
          <button
            ref={buttonRef}
            type="button"
            className={`${className.button} test-delete-suggest`}
            data-testid="test-delete-suggest-btn"
          >
            <img src={getImageUrl("images/icons/cancel.svg")} className={className.icon} />
          </button>
        </div>
        {dataType === "api_pulldown" ? (
          <>
            {selectTab === t("OutputSuggest.取得した値") ? (
              <>
                <PulldownSearchForm onSearchList={onSearchOutputs} seacrhMethodType="forwardMatch" />
                <PulldownList
                  outputs={currentOutputs}
                  onClickList={onClick}
                  isSearchCompleted={isSearchCompleted}
                  isSuggestClose={isSuggestClose}
                />
              </>
            ) : selectTab === t("OutputSuggest.候補") ? (
              <>
                {isYoomFlag ? (
                  <>
                    {isTrigger ? (
                      <DbTriggerSearchSelect
                        selections={selections}
                        terms={terms}
                        addTerm={onClickDbTriggerPulldown}
                        removeTerm={removeTerm}
                      />
                    ) : (
                      <DbOperationSearchSelect
                        selections={selections}
                        terms={terms}
                        addTerm={onClickDbTriggerPulldown}
                        removeTerm={removeTerm}
                      />
                    )}
                  </>
                ) : (
                  <>
                    <PulldownSearchForm onSearchList={onSearch} />
                    {pulldown?.length ? (
                      <ApiPulldownList pulldown={pulldown} onClickPulldown={onClickPulldown} formName={formName} />
                    ) : (
                      <>
                        {isPulldownFlg ? (
                          <div className={className.noResult}>{t("OutputSuggest.候補が見つかりませんでした")}</div>
                        ) : (
                          <div className={className.noResult}>{t("OutputSuggest.fetchingCandidatesMessage")}</div>
                        )}
                      </>
                    )}
                  </>
                )}
              </>
            ) : selectTab === t("OutputSuggest.基本情報") ? (
              <>
                {/* 基本情報タブが選択されている時 */}
                {dateOutputOptions && (
                  <BasicPulldownList
                    outputs={basicOutputs}
                    onClickList={onClick}
                    isSearchCompleted={isSearchCompleted}
                    isSuggestClose={isSuggestClose}
                    workflowTemplateTitle={workflowTemplateTitle}
                    workflowBootedAt={workflow_booted_at}
                    dateTimeFormat={dateOutputOptions.datetime_format}
                  />
                )}
              </>
            ) : (
              <>
                {/* 日付タブが選択されている時 */}
                {dateOutputOptions && (
                  <DatePulldownList
                    date={dateOutputOptions.date}
                    date_format={dateOutputOptions.date_format}
                    month={dateOutputOptions.month}
                    month_format={dateOutputOptions.month_format}
                    onClickList={onClick}
                    disable_suggest_date_types={disable_suggest_date_types}
                  />
                )}
              </>
            )}
          </>
        ) : (
          <>
            {selectTab === t("OutputSuggest.取得した値") ? (
              <>
                <PulldownSearchForm onSearchList={onSearchOutputs} seacrhMethodType="forwardMatch" />
                <PulldownList
                  outputs={currentOutputs}
                  onClickList={onClick}
                  isSearchCompleted={isSearchCompleted}
                  isSuggestClose={isSuggestClose}
                />
              </>
            ) : selectTab === t("OutputSuggest.基本情報") ? (
              <>
                {dateOutputOptions && (
                  <BasicPulldownList
                    outputs={basicOutputs}
                    onClickList={onClick}
                    isSearchCompleted={isSearchCompleted}
                    isSuggestClose={isSuggestClose}
                    workflowTemplateTitle={workflowTemplateTitle}
                    workflowBootedAt={workflow_booted_at}
                    dateTimeFormat={dateOutputOptions.datetime_format}
                  />
                )}
              </>
            ) : (
              <>
                {/* // 日付タブが選択されている時 */}
                {dateOutputOptions && (
                  <DatePulldownList
                    date={dateOutputOptions.date}
                    date_format={dateOutputOptions.date_format}
                    month={dateOutputOptions.month}
                    month_format={dateOutputOptions.month_format}
                    onClickList={onClick}
                    isSuggestClose={isSuggestClose}
                    disable_suggest_date_types={disable_suggest_date_types}
                  />
                )}
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
};

OutputSuggest.propTypes = {
  outputs: PropTypes.arrayOf(
    PropTypes.shape({
      operation_name: PropTypes.string,
      operation_icon_path: PropTypes.string,
      outputs: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.number.isRequired,
          display_name: PropTypes.string.isRequired,
          test_value: PropTypes.string,
        }).isRequired,
      ).isRequired,
      tab: PropTypes.string.isRequired,
    }).isRequired,
  ).isRequired,
  isTagsInput: PropTypes.bool,
  isTrix: PropTypes.bool,
  workflow_booted_at: PropTypes.string.isRequired,
  target: PropTypes.object,
  pulldown: PropTypes.array,
  dataType: PropTypes.string,
  onSearch: PropTypes.func,
  isPulldownFlg: PropTypes.bool,
  isTestFieldFlg: PropTypes.bool,
  formName: PropTypes.string,
  selections: PropTypes.array,
  addTerm: PropTypes.func,
  removeTerm: PropTypes.func,
  terms: PropTypes.array,
  isYoomFlag: PropTypes.bool,
  setTarget: PropTypes.func,
  isTrigger: PropTypes.bool,
  topAdjust: PropTypes.number,
  unnecessaryDateFlag: PropTypes.bool,
  disable_suggest_date_types: PropTypes.array,
  except_past: PropTypes.bool,
  setOutputs: PropTypes.func,
  styleOption: PropTypes.object,
  forceRender: PropTypes.bool,
};
